// removed by extract-text-webpack-plugin
module.exports = {"formInput":"styles__formInput___12U5Y","formTextArea":"styles__formTextArea___2UDW4"};


//////////////////
// WEBPACK FOOTER
// ./src/views/collaborate/collaborator-panel/note-form/styles.css
// module id = 1088
// module chunks = 0